import { render } from "./Recipient.vue?vue&type=template&id=a78431c8&ts=true"
import script from "./Recipient.vue?vue&type=script&lang=ts"
export * from "./Recipient.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__